import { createAction } from 'redux-actions';
import * as types from './draft-constants';

export const deleteDraftRequest = createAction(types.DELETE_DRAFT_REQUEST);
export const deleteDraftSuccess = createAction(types.DELETE_DRAFT_SUCCESS);
export const deleteDraftFailure = createAction(types.DELETE_DRAFT_FAILURE);

export const deleteAllDraftsRequest = createAction(types.DELETE_ALL_DRAFTS_REQUEST);
export const deleteAllDraftsSuccess = createAction(types.DELETE_ALL_DRAFTS_SUCCESS);
export const deleteAllDraftsFailure = createAction(types.DELETE_ALL_DRAFTS_FAILURE);
